// @flow
import { combineReducers } from 'redux';

import type { NEW_STOP_MARKER_ACTION_TYPE } from '../types/newStopMarker';
import * as types from '../types/newStopMarker';
import type { GEO_POINT_TYPE } from '../types/common';


export type NewStopMarkerState = {
  isPlaced: boolean,
  position: GEO_POINT_TYPE
};

const isPlaced = (state: boolean = false, action: NEW_STOP_MARKER_ACTION_TYPE): boolean => {
  switch (action.type) {
    case types.NEW_STOP_MARKER_ADDED: {
      return true;
    }
    case types.NEW_STOP_MARKER_REMOVED: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const defaultPoint = {
  type: 'Point',
  coordinates: [14.6019237, -90.4951822],
};

const position = (
  state: GEO_POINT_TYPE = defaultPoint,
  action: NEW_STOP_MARKER_ACTION_TYPE,
): GEO_POINT_TYPE => {
  switch (action.type) {
    case types.NEW_STOP_MARKER_ADDED:
    case types.NEW_STOP_MARKER_REPOSITIONED: {
      return action.payload;
    }
    case types.NEW_STOP_MARKER_REMOVED: {
      return defaultPoint;
    }
    default: {
      return state;
    }
  }
};


const newStopMarker = combineReducers({
  isPlaced,
  position,
});

export default newStopMarker;

export const isNewStopMarkerPlaced = (state: NewStopMarkerState): boolean => state.isPlaced;
export const getNewStopMarkerPosition = (
  state: NewStopMarkerState,
): GEO_POINT_TYPE => state.position;



// WEBPACK FOOTER //
// ./src/scripts/reducers/newStopMarker.js